import styled from 'styled-components';
import { List } from 'antd';

export const StyledListItem = styled(List.Item)`
  width: 100%;
  &:hover {
    background-color: #fafafa;
  }
`;
